const getLeadUUID = (analytics) => {
  const { userId, anonymousId } = analytics.user()

  return userId || anonymousId
}

export { getLeadUUID }
